//CompanyRecentActivityList
export const COMPANY_RECENT_ACTIVITY_LIST = "COMPANY_RECENT_ACTIVITY_LIST";
export const COMPANY_RECENT_ACTIVITY_LIST_SUCCESS =
  "COMPANY_RECENT_ACTIVITY_LIST_SUCCESS";
export const COMPANY_RECENT_ACTIVITY_LIST_FAILURE =
  "COMPANY_RECENT_ACTIVITY_LIST_FAILURE";
